import { removeUndefinedAndNullFields } from "base/shared/Utils";
import { PLANS_CATEGORIES } from "./constants";

const TRACKING_PLANS = {
  PRO: "pro",
  PLUS: "plus",
  BOOSTING: "boosting",
  UPSELL: "upsell",
  UNKNOWN: "",
};

const getPlan = (plan) => {
  switch (plan) {
    case PLANS_CATEGORIES.MATCHING:
      return TRACKING_PLANS.PLUS;
    case PLANS_CATEGORIES.STANDALONE_BOOSTING:
      return TRACKING_PLANS.BOOSTING;
    case PLANS_CATEGORIES.UPSELL_BADI_PLUS:
      return TRACKING_PLANS.UPSELL;
    default:
      return TRACKING_PLANS.UNKNOWN;
  }
};

const parseParams = ({ userId, roomId, unlock, capability }) => {
  const parsedParams = {
    room_id: roomId || null,
    unlock,
    user_id: userId,
    info_icon: capability,
  };
  removeUndefinedAndNullFields(parsedParams);

  return parsedParams;
};

export const badiPlanShown = (params) => {};

export const badiPlanContinueClick = (params) => {};

export const badiPlanRoomSelectorShown = (params) => {};

export const badiPlanRoomSelectorContinueClick = (params) => {};

export const badiPlanSuccessShown = (params) => {};

export const badiPlanBenefitInfoShown = (params) => {};

const badiPlansTrackingEvents = ({ roomId, unlock = "overview", userId }) => {
  return {
    badiPlanShown: (plan) => {
      badiPlanShown({ roomId, unlock, userId, plan });
    },
    badiPlanContinueClick: (plan) =>
      badiPlanContinueClick({ roomId, unlock, userId, plan }),
    badiPlanRoomSelectorShown: (plan) =>
      badiPlanRoomSelectorShown({ unlock, userId, plan }),
    badiPlanRoomSelectorContinueClick: ({
      roomId: selectedRoomId,
      category: plan,
    }) =>
      badiPlanRoomSelectorContinueClick({
        roomId: selectedRoomId,
        unlock,
        userId,
        plan,
      }),
    badiPlanSuccessShown: (plan) =>
      badiPlanSuccessShown({ roomId, unlock, userId, plan }),
    badiPlanBenefitInfoShown: (plan, capability) =>
      badiPlanBenefitInfoShown({ plan, capability, roomId, unlock, userId }),
  };
};

export default badiPlansTrackingEvents;
